import { render, staticRenderFns } from "./ModalLanguage.vue?vue&type=template&id=43dd9654"
import script from "./ModalLanguage.vue?vue&type=script&lang=js"
export * from "./ModalLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports